import { DEFAULT_INTERNAL_TOOLS_SETTINGS } from '@repo/internal-tools-app-lib/src/constants/internalToolsAppSettings.ts'
import type { SettingsConfig } from '@repo/internal-tools-app-lib/src/lib/settingStore/settingsConfigSchema.ts'
import { createUseSettingItemValueHook } from '@repo/internal-tools-app-lib/src/lib/settingStore/useSettingItemValue.ts'

export const CASE_APP_SETTINGS = {
  settingsId: 'ccc-case-app',
  sections: {
    appearance: DEFAULT_INTERNAL_TOOLS_SETTINGS.sections.appearance,
    featureFlags: {
      items: {
        'featureFlags.enableCaseAiAnalysis': {
          description: 'Enable AI analysis for cases.',
          type: 'boolean',
          default: true,
        },
        ...DEFAULT_INTERNAL_TOOLS_SETTINGS.sections.featureFlags.items,
      },
    },
  },
} as const satisfies SettingsConfig

export const useCaseAppSettingItemValue =
  createUseSettingItemValueHook(CASE_APP_SETTINGS)
